var _path, _circle, _circle2, _circle3, _circle4, _path2, _circle5, _path3, _path4, _circle6, _path5, _circle7, _path6, _path7, _path8, _circle8, _path9, _circle9, _path0, _path1, _circle0, _path10, _path11, _circle1, _path12, _path13, _path14, _circle10, _path15, _circle11, _path16, _circle12, _path17, _path18, _path19, _path20, _path21, _path22, _circle13, _path23, _path24, _path25, _circle14, _path26, _path27, _circle15, _circle16, _path28, _path29, _path30, _circle17, _circle18, _circle19, _path31, _path32, _path33, _path34, _circle20, _circle21, _path35, _circle22, _path36, _path37, _path38, _path39, _circle23, _circle24, _circle25, _path40, _circle26, _circle27, _path41, _path42, _path43, _path44, _circle28, _path45, _path46, _path47, _circle29, _path48, _circle30, _path49, _path50, _circle31, _circle32, _path51, _path52, _path53, _path54, _circle33;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1432,
    height: 817,
    viewBox: "0 0 1432 817",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M36.4531 38.9487L26.2002 23.7481C26.2002 23.7481 33.3185 22.8434 37.5792 20.9584C43.5023 18.338 45.509 3.99304 45.509 3.99304L58.8824 23.82C58.8824 23.82 48.099 23.3441 43.1815 27.243C39.0498 30.5188 36.4531 38.9487 36.4531 38.9487Z",
    fill: "#DAE9B8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142.11,
    cy: 43.1087,
    r: 5.2524,
    transform: "rotate(91 142.11 43.1087)",
    fill: "#EBCAEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.92,
    cx: 341.13,
    cy: 24.7154,
    r: 7.10995,
    transform: "rotate(113 341.13 24.7154)",
    fill: "#AA50B5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.76,
    cx: 570.291,
    cy: 10.1796,
    r: 7.87859,
    transform: "rotate(-17 570.291 10.1796)",
    fill: "#AA50B5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.77,
    cx: 622.382,
    cy: 54.6591,
    r: 7.87859,
    transform: "rotate(61 622.382 54.6591)",
    fill: "#AA50B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M794.453 24.9487L797.269 33.8243L779.156 45.5874L776.339 36.7119L794.453 24.9487Z",
    fill: "#FDD9B5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.88,
    cx: 939.306,
    cy: 67.5256,
    r: 5.95698,
    transform: "rotate(-136 939.306 67.5256)",
    fill: "#AA50B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M1039.45 38.9487L1029.27 43.1886L1013.52 23.027L1023.7 18.7872L1039.45 38.9487Z",
    fill: "#FDD9B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M1148.45 72.9487L1147.14 66.1698C1147.14 66.1698 1153.19 67.4314 1156.35 67.1324C1160.73 66.7167 1165.01 60.5547 1165.01 60.5547L1166.73 69.3967L1148.45 72.9487Z",
    fill: "#B2D6FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.82,
    cx: 1363.36,
    cy: 24.4087,
    r: 9.8002,
    transform: "rotate(86 1363.36 24.4087)",
    fill: "#AA50B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M107.453 113.949L98.4054 115.06C98.4054 115.06 100.624 107.204 100.521 103.02C100.378 97.2035 92.6572 91.0083 92.6572 91.0083L104.458 89.5593L107.453 113.949Z",
    fill: "#B2D6FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.78,
    cx: 222.478,
    cy: 114.374,
    r: 9.84824,
    transform: "rotate(173 222.478 114.374)",
    fill: "#EBCAEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M376.453 148.949L365.146 157.976L337.995 138.25L349.302 129.223L376.453 148.949Z",
    fill: "#FDD9B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M527.453 137.949L518.921 133.601C518.921 133.601 525.467 128.063 527.836 124.359C531.128 119.209 528.043 109.278 528.043 109.278L539.172 114.949L527.453 137.949Z",
    fill: "#B2D6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M577.453 110.949L571.098 108.76C571.098 108.76 575.107 104.272 576.391 101.465C578.177 97.5638 575.062 90.9624 575.062 90.9624L583.352 93.8167L577.453 110.949Z",
    fill: "#B2D6FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.99,
    cx: 817.792,
    cy: 130.586,
    r: 9.8002,
    transform: "rotate(111 817.792 130.586)",
    fill: "#AA50B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M899.985 143.121L903.704 160.842L885.194 162.136L881.475 144.416L899.985 143.121Z",
    fill: "#EBEDF0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.84,
    cx: 1085.38,
    cy: 171.966,
    r: 6.48543,
    transform: "rotate(-4 1085.38 171.966)",
    fill: "#4F5FEE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1219.03 142.125L1225.59 151.142L1209.19 167.805L1198.8 153.503L1219.03 142.125Z",
    fill: "#2D8FFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1383.45 152.949H1371.32C1371.32 152.949 1374.55 149.718 1374.96 145.468C1375.54 139.561 1371.32 127.88 1371.32 127.88H1383.45V152.949Z",
    fill: "#F77F00"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.73,
    cx: 121.248,
    cy: 214.76,
    r: 6.98985,
    transform: "rotate(52 121.248 214.76)",
    fill: "#4F5FEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M179 247.793L187.576 264.732L169.18 271.066L160.604 254.128L179 247.793Z",
    fill: "#EBEDF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M346.453 203.949L337.389 210.063C337.389 210.063 336.849 205.818 335.725 203.277C334.162 199.745 325.608 198.548 325.608 198.548L337.431 190.573C337.431 190.573 337.148 197.004 339.473 199.936C341.426 202.4 346.453 203.949 346.453 203.949Z",
    fill: "#DAE9B8"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.91,
    cx: 502.32,
    cy: 219.905,
    r: 8.61721,
    transform: "rotate(111 502.32 219.905)",
    fill: "#EBCAEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M680.453 231.949L676.855 240.424C676.855 240.424 671.104 234.516 667.392 232.493C662.231 229.681 652.913 233.306 652.913 233.306L657.605 222.25L680.453 231.949Z",
    fill: "#B2D6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M800.453 184.949L807.556 189.217C807.556 189.217 801.571 193.602 799.303 196.657C796.15 200.905 798.213 209.664 798.213 209.664L788.948 204.097L800.453 184.949Z",
    fill: "#B2D6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M997.453 233.949L990.182 243.957C990.182 243.957 989.449 239.361 986.192 236.47C981.664 232.452 969.499 228.93 969.499 228.93L976.77 218.922L997.453 233.949Z",
    fill: "#F77F00"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.88,
    cx: 1036.98,
    cy: 188.33,
    r: 9.70412,
    transform: "rotate(146 1036.98 188.33)",
    fill: "#AA50B5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M1207.45 238.949L1203.46 229.541C1203.46 229.541 1212.61 229.504 1217.09 228.1C1223.31 226.148 1227.61 215.912 1227.61 215.912L1232.81 228.184L1207.45 238.949Z",
    fill: "#B2D6FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.96,
    cx: 1373.78,
    cy: 254.407,
    r: 9.02755,
    transform: "rotate(10 1373.78 254.407)",
    fill: "#EBCAEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M136.453 277.949L144.401 282.8L138.448 303.561L130.5 298.71L136.453 277.949Z",
    fill: "#FDD9B5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.74,
    cx: 256.893,
    cy: 285.1,
    r: 10.4728,
    transform: "rotate(167 256.893 285.1)",
    fill: "#AA50B5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M321.453 342.949L333.493 341.127L344.981 366.929L332.941 368.751L321.453 342.949Z",
    fill: "#FDD9B5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M497.453 344.949L488.225 339.404C488.225 339.404 491.789 337.156 493.588 335.096C496.09 332.232 493.598 324.1 493.598 324.1L505.635 331.332C505.635 331.332 499.778 333.755 498.129 337.05C496.743 339.818 497.453 344.949 497.453 344.949Z",
    fill: "#DAE9B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M606.686 280.508L599.364 278.682L600.616 262.904L612.23 265.799L606.686 280.508Z",
    fill: "#2D8FFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M851.453 275.949L868.728 282.58C868.728 282.58 863.367 287.448 860.936 291.473C857.556 297.067 864.201 310.087 864.201 310.087L841.669 301.438C841.669 301.438 850.858 295.59 852.667 289.52C854.186 284.421 851.453 275.949 851.453 275.949Z",
    fill: "#DAE9B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M937.453 331.949L932.886 323.359C932.886 323.359 936.387 324.425 939.553 323.12C943.954 321.305 950.638 313.921 950.638 313.921L955.205 322.51L937.453 331.949Z",
    fill: "#F77F00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M1067.64 329.596L1066.89 343.112L1053.28 340.465L1054.02 326.949L1067.64 329.596Z",
    fill: "#EBEDF0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1176.13,
    cy: 307.978,
    r: 5.90895,
    transform: "rotate(-8 1176.13 307.978)",
    fill: "#4F5FEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M1426.45 300.949L1410.98 303.015L1396.82 269.676L1412.3 267.61L1426.45 300.949Z",
    fill: "#FDD9B5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M0.453125 401.949L11.4326 393.972C11.4326 393.972 10.6396 399.015 13.0579 403.135C16.4198 408.863 27.9185 416.663 27.9185 416.663L16.939 424.64L0.453125 401.949Z",
    fill: "#F77F00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M227.453 405.949L232.557 413.516C232.557 413.516 229.186 412.865 226.36 414.393C222.431 416.519 216.918 424.064 216.918 424.064L211.814 416.497L227.453 405.949Z",
    fill: "#F77F00"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 355.27,
    cy: 453.252,
    r: 7.39819,
    transform: "rotate(35 355.27 453.252)",
    fill: "#AA50B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M467.453 442.949L466.53 449.514C466.53 449.514 461.43 446.477 458.471 445.761C454.358 444.767 448.553 449.025 448.553 449.025L449.756 440.462L467.453 442.949Z",
    fill: "#B2D6FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M602.453 379.949L602.959 370.294C602.959 370.294 610.755 374.058 615.145 374.721C621.247 375.642 629.139 368.719 629.139 368.719L628.479 381.313L602.453 379.949Z",
    fill: "#B2D6FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.94,
    cx: 750.112,
    cy: 429.347,
    r: 9.12764,
    transform: "rotate(-109 750.112 429.347)",
    fill: "#AA50B5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.95,
    cx: 985.879,
    cy: 457.095,
    r: 9.35583,
    transform: "rotate(-7 985.879 457.095)",
    fill: "#EBCAEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M1101.45 448.949L1116.37 447.644C1116.37 447.644 1114.2 453.086 1113.85 456.874C1113.38 462.142 1122.83 469.253 1122.83 469.253L1103.38 470.955C1103.38 470.955 1107.99 463.443 1107.15 458.387C1106.45 454.14 1101.45 448.949 1101.45 448.949Z",
    fill: "#DAE9B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M1186.45 445.949L1192.21 448.634C1192.21 448.634 1188 452.457 1186.51 454.968C1184.45 458.459 1186.73 464.973 1186.73 464.973L1179.22 461.47L1186.45 445.949Z",
    fill: "#B2D6FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1429.29 437.024L1432 452.612L1415.8 453.178L1413.09 437.59L1429.29 437.024Z",
    fill: "#EBEDF0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.88,
    cx: 107.496,
    cy: 533.16,
    r: 9.99236,
    transform: "rotate(126 107.496 533.16)",
    fill: "#AA50B5"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.88,
    cx: 163.767,
    cy: 456.181,
    r: 9.41588,
    transform: "rotate(-44 163.767 456.181)",
    fill: "#AA50B5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.89,
    cx: 307.275,
    cy: 515.745,
    r: 8.07075,
    transform: "rotate(-146 307.275 515.745)",
    fill: "#AA50B5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M450.453 450.949L438.865 448.059C438.865 448.059 441.916 444.519 443.157 441.749C444.882 437.899 439.601 430.081 439.601 430.081L454.716 433.849C454.716 433.849 449.289 438.319 448.608 442.35C448.036 445.736 450.453 450.949 450.453 450.949Z",
    fill: "#DAE9B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M630.453 493.949L636.927 494.859C636.927 494.859 633.932 499.889 633.227 502.806C632.246 506.863 636.445 512.587 636.445 512.587L628.001 511.4L630.453 493.949Z",
    fill: "#B2D6FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M738.346 471.856L728.529 459.225L742.727 451.028L752.543 463.659L738.346 471.856Z",
    fill: "#EBEDF0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M869.85 524.2L886.77 526.321L882.247 543.2L865.327 541.079L869.85 524.2Z",
    fill: "#EBEDF0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.92,
    cx: 1125.22,
    cy: 485.18,
    r: 7.87859,
    transform: "rotate(101 1125.22 485.18)",
    fill: "#EBCAEF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1216.27,
    cy: 518.288,
    r: 5.47658,
    transform: "rotate(172 1216.27 518.288)",
    fill: "#4F5FEE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M1304.45 536.949L1296.09 534.958L1295.4 515.033L1303.76 517.025L1304.45 536.949Z",
    fill: "#FDD9B5"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.82,
    cx: 78.4135,
    cy: 593.578,
    r: 6.84573,
    transform: "rotate(7 78.4135 593.578)",
    fill: "#4F5FEE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M176.511 591.873L160.402 586.28L168.335 570.71L184.444 576.303L176.511 591.873Z",
    fill: "#EBEDF0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M360.453 574.949L351.912 582.804L329.087 568.542L337.628 560.687L360.453 574.949Z",
    fill: "#FDD9B5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M570.943 581.647L572.97 572.108L593.405 573.013L590.189 588.144L570.943 581.647Z",
    fill: "#2D8FFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M614.453 542.949L597.277 542.231L588.308 503.379L605.484 504.098L614.453 542.949Z",
    fill: "#FDD9B5"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.94,
    cx: 835.723,
    cy: 574.78,
    r: 7.13397,
    transform: "rotate(32 835.723 574.78)",
    fill: "#4F5FEE"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.87,
    cx: 888.664,
    cy: 630.325,
    r: 6.98985,
    transform: "rotate(127 888.664 630.325)",
    fill: "#4F5FEE"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.77,
    cx: 1126.42,
    cy: 616.569,
    r: 10.761,
    transform: "rotate(144 1126.42 616.569)",
    fill: "#AA50B5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1241.45 551.949L1229.56 541.83L1244.87 509.005L1256.76 519.124L1241.45 551.949Z",
    fill: "#FDD9B5"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.95,
    cx: 1308.75,
    cy: 608.529,
    r: 11.1453,
    transform: "rotate(-173 1308.75 608.529)",
    fill: "#AA50B5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.97,
    cx: 22.5013,
    cy: 710.486,
    r: 7.59035,
    transform: "rotate(34 22.5013 710.486)",
    fill: "#AA50B5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M173.453 645.949L170.425 637.156C170.425 637.156 178.735 637.704 182.888 636.714C188.663 635.337 193.207 626.318 193.207 626.318L197.156 637.788L173.453 645.949Z",
    fill: "#B2D6FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M294.453 658.949L282.1 655.407C282.1 655.407 286.326 653.058 287.99 648.852C290.304 643.004 289.421 629.878 289.421 629.878L301.774 633.42L294.453 658.949Z",
    fill: "#F77F00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M461.453 711.949L457.371 696.284L489.888 677.511L493.97 693.176L461.453 711.949Z",
    fill: "#FDD9B5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M639.453 714.949L652.678 718.493C652.678 718.493 648.22 721.073 646.525 725.585C644.169 731.857 645.355 745.824 645.355 745.824L632.13 742.281L639.453 714.949Z",
    fill: "#F77F00"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.92,
    cx: 804.805,
    cy: 714.145,
    r: 7.13397,
    transform: "rotate(104 804.805 714.145)",
    fill: "#4F5FEE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M976.453 686.949L968.885 685.886C968.885 685.886 972.386 680.006 973.211 676.595C974.357 671.853 969.449 665.161 969.449 665.161L979.32 666.548L976.453 686.949Z",
    fill: "#B2D6FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M1037.45 631.949L1026.58 633.285C1026.58 633.285 1029.24 623.842 1029.12 618.813C1028.95 611.821 1019.67 604.374 1019.67 604.374L1033.85 602.633L1037.45 631.949Z",
    fill: "#B2D6FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M1166.45 694.949L1163.45 702.772C1163.45 702.772 1158.03 697.581 1154.59 695.859C1149.81 693.466 1141.45 697.058 1141.45 697.058L1145.37 686.855L1166.45 694.949Z",
    fill: "#B2D6FF"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.84,
    cx: 1311.02,
    cy: 673.626,
    r: 6.82171,
    transform: "rotate(106 1311.02 673.626)",
    fill: "#AA50B5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M89.4531 724.949L108.357 726.936C108.357 726.936 104.332 733.192 102.99 737.832C101.124 744.282 111.179 755.435 111.179 755.435L86.5214 752.843C86.5214 752.843 94.0851 744.596 94.2657 738.093C94.4174 732.629 89.4531 724.949 89.4531 724.949Z",
    fill: "#DAE9B8"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.71,
    cx: 260.309,
    cy: 792.295,
    r: 6.34131,
    transform: "rotate(80 260.309 792.295)",
    fill: "#AA50B5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M354.453 798.949L344.243 788C344.243 788 349.868 786.361 353.063 784.297C357.505 781.427 357.291 769.602 357.291 769.602L370.609 783.884C370.609 783.884 361.852 784.877 358.384 788.65C355.47 791.819 354.453 798.949 354.453 798.949Z",
    fill: "#DAE9B8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M554.453 803.949L560.728 801.54C560.728 801.54 560.542 807.556 561.362 810.532C562.503 814.668 569.131 817.723 569.131 817.723L560.946 820.865L554.453 803.949Z",
    fill: "#B2D6FF"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.82,
    cx: 686.046,
    cy: 805.829,
    r: 10.0884,
    transform: "rotate(115 686.046 805.829)",
    fill: "#AA50B5"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 751.843,
    cy: 802.771,
    r: 8.20687,
    transform: "rotate(-9 751.843 802.771)",
    fill: "#EBCAEF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M982.453 804.949L975.088 804.821C975.088 804.821 977.747 798.784 978.135 795.424C978.674 790.754 973.193 784.928 973.193 784.928L982.8 785.096L982.453 804.949Z",
    fill: "#B2D6FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1115.45 794.949L1127.41 800.274C1127.41 800.274 1122.82 802.044 1120.54 806.051C1117.38 811.622 1116.41 824.989 1116.41 824.989L1104.45 819.665L1115.45 794.949Z",
    fill: "#F77F00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M1152.67 781.638L1148.2 765.911L1164.79 763.58L1169.26 779.307L1152.67 781.638Z",
    fill: "#EBEDF0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M1314.65 791.21L1315.47 800.579L1296.37 805.505L1295.07 790.645L1314.65 791.21Z",
    fill: "#2D8FFF"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1244.17,
    cy: 818.351,
    r: 6.62955,
    transform: "rotate(107 1244.17 818.351)",
    fill: "#4F5FEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizConfetti);
export default __webpack_public_path__ + "static/media/quiz-confetti.d32bbb864f6a00d3b7263e87c2bd20a8.svg";
export { ForwardRef as ReactComponent };